import { ElementType } from 'react';
import { __DEV__ } from '../../utils';
import { Button, ButtonProps } from '../button';

interface CustomIconButtonProps {
  icon: ElementType;
  sizePx?: string;
}

export interface IconButtonProps extends ButtonProps, CustomIconButtonProps {}

const IconButton = (props: IconButtonProps) => {
  const { icon: Icon, ...rest } = props;

  const styles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <Button style={styles} {...rest}>
      <Icon />
    </Button>
  );
};

if (__DEV__) {
  IconButton.displayName = 'IconButton';
}

export { IconButton };
